import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledConfirmText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledDeleteIcon = styled(FontAwesomeIcon)`
  & {
    height: 2.4rem;
    width: 2.4rem;
    color: ${({ theme }) => theme.colors.error.main};
  }
`;
